import { render, staticRenderFns } from "./InformationPopup.vue?vue&type=template&id=20b9aa8a&scoped=true&"
import script from "./InformationPopup.vue?vue&type=script&lang=js&"
export * from "./InformationPopup.vue?vue&type=script&lang=js&"
import style0 from "./InformationPopup.vue?vue&type=style&index=0&id=20b9aa8a&lang=scss&scoped=true&"
import style1 from "./InformationPopup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9aa8a",
  null
  
)

export default component.exports